import * as types from "./actionTypes";
import axios from "axios";

import { environmentDetails } from "../../environment/environment";
import { privateAxiosInstance } from "../../utils/axiosInstance";
import { accessTokenHeadersObject } from "../../utils/headers";
import countriesData from "./countryjson.json";

const apiUrl = environmentDetails.apiUrl;
const countryUrl = environmentDetails.countryUrl;
const cityUrl = environmentDetails.cityUrl;

const getCountryData = () => (dispatch) => {
  dispatch({ type: types.GET_COUNTRY_REQUEST });
  return privateAxiosInstance
    .get(`/questionnaire/get-allcountry`, {
      headers: { ...accessTokenHeadersObject() },
    })
    .then((res) => {
      return dispatch({
        type: types.GET_COUNTRY_SUCCESS,
        payload: res.data.data,
        datalength: res.data.dataLength,
      });
    })
    .catch((err) => {
      // console.log("err", err);
      return dispatch({ type: types.GET_COUNTRY_FAILURE, payload: err });
    });
};

const getCountryName = () => (dispatch) => {
  dispatch({ type: types.GET_COUNTRY_NAME_REQUEST });
  return axios
    .get(countryUrl)
    .then((res) => {
      return dispatch({
        type: types.GET_COUNTRY_NAME_SUCCESS,
        payload: res.data.data,
      });
    })
    .catch((err) => {
      // console.log("err", err);
      return dispatch({ type: types.GET_COUNTRY_NAME_FAILURE, payload: err });
    });
};

// const getCityName =(data) => (dispatch) => {
//   dispatch({ type: types.GET_CITY_NAME_REQUEST});
//   return axios.post(
//       cityUrl,data
//     )
//     .then((res) => {
//       return dispatch({
//         type: types.GET_CITY_NAME_SUCCESS,
//         payload: res.data,
//       });
//     })
//     .catch((err) => {
//      // console.log("err", err);
//       return dispatch({ type: types.GET_CITY_NAME_FAILURE, payload: err });
//     });
// }

// const getCityName = (data) => (dispatch) => {
//   console.log("country name", data);
//   const country =
//     typeof data === "string"
//       ? data
//       : typeof data === "object" && data !== null
//       ? data.value || data.name || ""
//       : "";

//   console.log("country final:", country);

//   const result = countriesData.countryjson.find(
//     (item) => item.name.toLowerCase() === country.toLowerCase()
//   );
//   console.log("result",result);
  
//   //countriesData.countryjson[0]
//   if (result) {
//     return dispatch({
//       payload: result
//     });
//   } else {
//     console.warn(`No cities found for: ${country}`);
//   }
// };

// const getCityName = (data) => (dispatch) => {
//   console.log("country name:", data);
//   console.log("type of data",typeof(data));
  

//   const result = countriesData.countryjson.find(
//     (item) => item.name.toLowerCase() === data.toLowerCase()
//   );

//   if (result) {
//     const cities = result.cities || [];

//     console.log(cities);
    
    
//     return dispatch({
//       type: "GET_CITIES_SUCCESS",
//       payload: cities,
//     });
//   } else {
//     console.warn(`No cities found for: ${data}`);
    
//     return dispatch({
//       type: "GET_CITIES_FAILED",
//       payload: [],
//     });
//   }
// };


const getCityName = (data) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const result = countriesData.countryjson.find(
      (item) => item.name.toLowerCase() === data.toLowerCase()
    );

    if (result) {
      dispatch({
        type: "GET_CITIES_SUCCESS",
        payload: result.cities || [],
      });
      resolve(result.cities);
    } else {
      dispatch({
        type: "GET_CITIES_FAILED",
        payload: [],
      });
      reject(`No cities found for: ${data}`);
    }
  });
};



export { getCountryData, getCountryName, getCityName };
